import React from "react";
import { Link } from "react-router-dom";
import { replaceParams } from "core/utils";
import { candidate } from "routes/paths";
import { Button } from "components/generic/kit";
import { InsiderCard, BookWrap } from "components/common/candidate";

export default ({
  location,
  isLoading,
  booking,
  booking: { insider, time_slot },
  date,
  onCancel
}) => (
  <BookWrap
    bigTitle="Cancel Call"
    isLoading={isLoading}
    sidebar={<InsiderCard {...insider} {...booking} />}
  >
    {() => (
      <div>
        <div className="fw6 f4">Are you sure you want to cancel your call?</div>
        <div className="gray f6">
          <div className="mt2">
            You are about to cancel your call with{" "}
            <span className="black fw5">
              {insider.company.title_name} at {insider.company.company.name}
            </span>{" "}
            scheduled at the <span className="black fw5">{date}</span>.
          </div>
          <div className="mt2">
            Please bear in mind that once a call is scheduled with our insiders,
            it’s an inconvenience for them to reschedule because they’re taking
            time out of their busy schedules to hop on these calls. If you’re
            still sure you want to cancel,{" "}
            <span className="underline pointer black fw5" onClick={onCancel}>
              go ahead
            </span>.
          </div>
          <div className="mt2 mb3">
            If you’d like to reschedule click below. Remember that you also have
            the option of reschedule the call clicking
          </div>
        </div>
        <Link
          to={
            replaceParams(candidate.reschedule, { id: insider.id }) +
            location.search
          }
        >
          <Button size="small">Reschedule call</Button>
        </Link>
      </div>
    )}
  </BookWrap>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/CancelCall/View.js